module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "do-filters"
  }, [_c('div', {
    staticClass: "do-filters__selected"
  }, [_c('DDropdown', {
    attrs: {
      "isShowDots": false,
      "propOffset": [0, 8],
      "isCloseOnDropdownClick": false,
      "closeFromProp": _vm.closeFromProp
    },
    on: {
      "onClose": _vm.onCloseDropdown
    }
  }, [_c('button', {
    staticClass: "do-bttn do-bttn__filter",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    staticClass: "icon-filter"
  }), _vm._v("\n        " + _vm._s(_vm.resolvedTitle) + "\n        "), _c('div', {
    staticClass: "do-filters__divider"
  }), _vm._v(" "), (_vm.selectedTags.length === 0) ? _c('span', {
    staticClass: "do-filters__selected-filters"
  }, [_vm._v("\n          " + _vm._s(_vm.placeholder ? _vm.placeholder : _vm.i18n['select_filters']) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.selectedTags.length > _vm.numberOfSelectedTagsToShow) ? _c('span', {
    staticClass: "do-badge"
  }, [_vm._v("\n          " + _vm._s(_vm.selectedTags.length) + " " + _vm._s(_vm.i18n['selected']) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.selectedTags), function(selectedTag) {
    return (_vm.selectedTags.length <= _vm.numberOfSelectedTagsToShow) ? _c('span', {
      key: selectedTag,
      staticClass: "do-badge"
    }, [_vm._v("\n          " + _vm._s(selectedTag) + "\n        ")]) : _vm._e()
  }), _vm._v(" "), (_vm.selectedTags.length > 0) ? _c('span', {
    staticClass: "icon-cross2 do-filters__clear",
    attrs: {
      "title": _vm.i18n['clear_all']
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clearAll.apply(null, arguments)
      }
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('ul', {
    staticClass: "do-filters__filter__dropdown",
    attrs: {
      "slot": "list"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    },
    slot: "list"
  }, [_c('div', {
    staticClass: "do-filters__filter__dropdown__header"
  }, [(_vm.selectedTags.length === 0) ? _c('button', {
    staticClass: "do-filters__button-transparent",
    on: {
      "click": _vm.selectAll
    }
  }, [_vm._v(_vm._s(_vm.i18n['select_all']))]) : _c('button', {
    staticClass: "do-filters__button-transparent",
    on: {
      "click": _vm.clearAll
    }
  }, [_vm._v(_vm._s(_vm.i18n['clear_all']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    attrs: {
      "type": "search",
      "placeholder": _vm.i18n['search_placeholder']
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._l((_vm.filteredTags), function(item) {
    return _c('li', {
      key: item,
      staticClass: "do-list-item",
      on: {
        "click": function($event) {
          return _vm.select(item)
        }
      }
    }, [_c('div', {
      staticClass: "do-checkbox",
      class: {
        'do-checkbox--selected': _vm.getIsItemSelected(item)
      }
    }), _vm._v("\n          " + _vm._s(item) + "\n        ")])
  }), _vm._v(" "), (_vm.filteredTags.length === 0) ? _c('li', {
    staticClass: "italic"
  }, [_vm._v(_vm._s(_vm.i18n['no_results']))]) : _vm._e()], 2)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bbe2e5fc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DoFilters/DoFiltersFilter.vue
// module id = 2106
// module chunks = 1